import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  content: {
    flex: 1,
    minHeight: 0 as any,
    backgroundColor: white,
  },
  titleText: {
    color: '#556B2F',
  },
  button: {
    marginVertical: indent * 0.6,
    paddingVertical: indent * 0.2,
  },
  contentContainer: {},
  container: {
    backgroundColor: white,
    alignItems: 'center',
  },
  title: {
    fontSize: 22,
    color: '#556B2F',
    marginBottom: 4,
    paddingTop: 10,
  },
  subtitle: {
    fontSize: 14,
    marginBottom: 12,
  },
  buttonContainer: {
    flexDirection: 'row',
    gap: 20,
  },
  streakButton: {
    backgroundColor: '#E6F0FF',
    paddingVertical: 10,
    paddingHorizontal: 22,
    borderRadius: 20,
  },
  streakText: {
    color: '#3B28CC',
    fontSize: 16,
  },
  shareButton: {
    backgroundColor: '#aaa',
    paddingVertical: 8,
    paddingHorizontal: 20,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  shareText: {
    color: white,
  },
  loader: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
});

export const webScrollStyle = {
  height: '100vh',
  overflowY: 'auto',
  paddingBottom: 40,
};
